export const SET_GUEST_OPTIONS = '/GuestOptions/*/Update';
